// FinalCTA — closing CTA section | "You're in the right place." heading + institution demo button + student match-call link

import { motion, useReducedMotion } from 'framer-motion'
import { useWindowWidth } from '../../hooks/useWindowWidth'
import { CALENDLY_URL } from '../../constants'

const EASE = [0.22, 1, 0.36, 1] as const;

function FinalCTA() {
  const width = useWindowWidth()
  const isMobile = width < 768
  const prefersReduced = useReducedMotion()

  return (
    <section
      style={{
        padding: isMobile ? '80px 0 60px' : '140px 0 100px',
        textAlign: 'center',
      }}
    >
      <motion.div
        style={{
          maxWidth: 760,
          margin: '0 auto',
          padding: '0 24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 32,
        }}
        initial={prefersReduced ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.7, ease: EASE }}
      >
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.3)',
            margin: 0,
          }}
        >
          GET STARTED
        </p>

        <h2
          style={{
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: isMobile ? 'clamp(32px, 8vw, 72px)' : 72,
            fontWeight: 700,
            color: '#FFFFFF',
            lineHeight: 1.1,
            margin: 0,
          }}
        >
          You're in the right place.
        </h2>

        <a
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="landing-cta"
          style={{
            padding: isMobile ? '14px 28px' : '16px 36px',
            fontSize: isMobile ? '14px' : '15px',
            fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          Book a Demo →
        </a>

        <a
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="landing-secondary"
        >
          I'm a student — book a free intro call →
        </a>
      </motion.div>
    </section>
  )
}

export default FinalCTA
